// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:55:42

export default {
  "id": "among-squid-challenge-online",
  "slug": "among-squid-challenge-online",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d145682158474d24a68759c6a8d668cf-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d145682158474d24a68759c6a8d668cf/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Among Squid Challenge Online",
      "description": "All players, get ready. They are hiding in a maze. To win the game, you must defeat all the other players. You have a knife and must defeat everyone. Catch the players one by one and make sure they are eliminated. Don’t worry, they won’t find you. If they try to find you, hide in the ventilation holes. Defeat all the players. Be careful, and whatever you do, don't reveal yourself. If they catch you, you will lose and they will defeat you.",
      "instructions": "*Use the \"Arrow keys\" to move.\n*The game is playable on both mobile and PC.\n*Press the \"Space\" key to kill players.\n*Use the buttons to hide and view the map.",
      "genres": [
        "Battle",
        "Casual"
      ],
      "tags": [
        "2d",
        "amongus",
        "arcade",
        "battleroyale",
        "squidgame"
      ]
    },
    "zh-CN": {
      "title": "在线章鱼挑战赛",
      "description": "所有玩家，准备。他们隐藏在一个迷宫里。为了赢得游戏，你必须击败所有其他玩家。你有一把刀，必须击败所有人。逐个捕捉玩家，并确保他们被淘汰。别担心，他们找不到你。如果他们试图找到你，就躲进通风孔里。击败所有玩家。小心，无论你做什么，都不要暴露自己。如果他们抓住了你，你就会输，他们就会击败你。",
      "instructions": "*使用“箭头键”移动。\n*游戏可在移动设备和PC上玩。\n*按“空格键”杀死玩家。\n*使用按钮隐藏和查看地图。",
      "genres": [
        "战斗",
        "休闲"
      ],
      "tags": [
        "2D",
        "我们之中",
        "街机",
        "斗鱼竞技场",
        "鱿鱼游戏"
      ]
    },
    "zh-TW": {
      "title": "網路章魚挑戰賽",
      "description": "所有玩家，準備好。他們躲在迷宮裡。要贏得遊戲，你必须擊敗所有其他玩家。你有一把刀，必須擊敗所有人。一個一個捕捉玩家，並確保他們被消除。不用擔心，他們找不到你。如果他們試圖找到你，就躲在通風孔裡。擊敗所有玩家。小心，無論你做什麼，都不要暴露自己。如果他們抓到你，你就會輸，他們會擊敗你。",
      "instructions": "*使用「方向鍵」來移動。\n*遊戲可在手機及PC上遊玩。\n*按「空格鍵」殺死玩家。\n*使用按鈕來隱藏和查看地圖。",
      "genres": [
        "戰鬥",
        "休闲"
      ],
      "tags": [
        "2D",
        "Among Us",
        "街機",
        "大逃殺",
        "魚貝遊戲"
      ]
    },
    "zh-HK": {
      "title": "squid challenge 在線版",
      "description": "所有玩家，準備好。他們正藏在一個迷宮中。要贏得遊戲，你必須擊敗所有其他玩家。你有一把刀，必須擊敗所有人。一個一個捕捉玩家，並確保他們被淘汰。不用擔心，他們找不到你。如果他們試圖找到你，就躲進通風孔。擊敗所有玩家。小心，無論你做什麼，都不要暴露自己。如果他們抓住你，你將會輸掉，他們將會擊敗你。",
      "instructions": "*使用「方向鍵」來移動。\n*遊戲可在手機及電腦上遊玩。\n*按「空格鍵」殺死玩家。\n*使用按鈕來隱藏和查看地圖。",
      "genres": [
        "戰鬥",
        "休闲"
      ],
      "tags": [
        "2D",
        "我們都是星人",
        "街機",
        "大逃殺",
        "鬥魚遊戲"
      ]
    },
    "ja": {
      "title": "スQuidチャレンジオンライン",
      "description": "全員、準備です。彼らは迷路に隠れています。ゲームを勝つには、他の全てのプレイヤーを倒さなければなりません。あなたにはナイフがあり、全員を倒さなければなりません。プレイヤーを一人ずつ捕まえ、排除してください。心配しないで、彼らはあなたを見つけません。彼らが見つけようとするなら、通風孔に隠れてください。全てのプレイヤーを倒してください。慎重に行い、何をしても自分をさらけ出さないようにしてください。もし捕まったら、あなたは負け、彼らが勝利します。",
      "instructions": "*「矢印キー」を使用して移動してください。\n*モバイルとPCの両方でプレイ可能です。\n*「スペースキー」を押してプレイヤーを殺してください。\n*ボタンを使用して地図を隠すか表示してください。",
      "genres": [
        "バトル",
        "カジュアル"
      ],
      "tags": [
        "2D",
        "アミューズメント",
        "バトルロイヤル",
        "スクイッドゲーム"
      ]
    },
    "ko": {
      "title": "오징어 도전 온라인",
      "description": "모든 플레이어, 준비하세요. 그들은 룬에 숨어 있습니다. 게임을 이기기 위해 다른 모든 플레이어를 궁지에 몰아넣어야 합니다. 당신은 칼을 가지고 있으며 모든 사람을 궁지에 몰아넣어야 합니다. 플레이어를 하나씩 잡고 제거해야 합니다. 걱정하지 마세요, 그들은 당신을 찾지 못합니다. 그들이 찾으려고 하면 통풍구에 숨어하세요. 모든 플레이어를 궁지에 몰아넣으세요. 조심스럽게 하고, 무엇이든 하지 말고 자신을 드러내지 마세요. 그들이 잡으면 당신은 패배하고 그들은 당신을 궁지에 몰아넣습니다.",
      "instructions": "*아이언키를 사용하여 이동하세요.\n*모바일과 PC 모두에서 게임이 가능합니다.\n*스페이스바를 눌러 플레이어를 죽입니다.\n*버튼을 사용하여 맵을 숨기고 보여줍니다.",
      "genres": [
        "전투",
        "캐주얼"
      ],
      "tags": [
        "2D",
        "아몬스",
        "아케이드",
        "배틀로얄",
        "오징어게임"
      ]
    },
    "fr": {
      "title": "Sur le Défi des Calmar en Ligne",
      "description": "Tous les joueurs, soyez prêts. Ils se cachent dans un labyrinthe. Pour gagner le jeu, vous devez battre tous les autres joueurs. Vous avez un couteau et vous devez battre tout le monde. Capturez les joueurs un par un et assurez-vous qu'ils sont éliminés. Ne vous inquiétez pas, ils ne vous trouveront pas. S'ils essaient de vous trouver, cachez-vous dans les orifices de ventilation. Battez tous les joueurs. Soyez prudent, et peu importe ce que vous faites, ne vous dévoilez pas. S'ils vous capturent, vous perdez et ils vous battent.",
      "instructions": "*Utilisez les \"Touches fléchées\" pour vous déplacer.\n*Le jeu est jouable sur mobile et PC.\n*Appuyez sur la touche \"Espace\" pour tuer les joueurs.\n*Utilisez les boutons pour cacher et afficher la carte.",
      "genres": [
        "Bataille",
        "Loisir"
      ],
      "tags": [
        "2D",
        "Among Us",
        "arcade",
        "battle royale",
        "Squid Game"
      ]
    }
  }
};
